var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowLeftSml = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.522,
    height: 15.282,
    viewBox: "0 0 16.522 15.282",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M.467,9.688a1.472,1.472,0,0,1,2.04-2.121l3.111,3.009V1.455a1.476,1.476,0,0,1,2.951,0v9.121l3.112-3.009a1.472,1.472,0,0,1,2.04,2.121L8.193,15.035a1.481,1.481,0,0,1-2.2,0Z",
    transform: "translate(16.023 0.5) rotate(90)",
    stroke: "#fff",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowLeftSml, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-left-sml.743fa462.svg";
export { ForwardRef as ReactComponent };